import { createSlice } from '@reduxjs/toolkit'

import { driversAdapter } from './driversAdapters'
import { saveDriver } from './thunks/saveDriver'
import { toggleDriverStatus } from './thunks/toggleDriverStatus'

export const initialDriverState = driversAdapter.getInitialState()

export const driversSlice = createSlice({
  name: 'drivers',
  initialState: initialDriverState,
  reducers: {
    upsertMultipleDrivers: (state, action) => {
      driversAdapter.upsertMany(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveDriver.fulfilled, (state, action) => {
        driversAdapter.upsertOne(state, action.payload)
      })
      .addCase(toggleDriverStatus.fulfilled, (state, action) => {
        const id = action.payload

        if (!id) return

        const driver = state.entities[id]

        if (driver) {
          driver.isActive = !driver.isActive
        }
      })
  },
})

export const { upsertMultipleDrivers } = driversSlice.actions